<template>
  <component
    :is="tag || 'div'"
    class="img-wrapper"
    v-bind="wrapAttr"
    ref="target"
  >
    <img
      v-if="isLoaded == 1"
      class="loaded"
      :src="src"
      alt=""
      v-bind="imagAttr"
    />
    <IconLoader v-if="isLoaded != 1" />
  </component>
</template>

<script setup>
import { loadImage } from "~/helpers/file";
const props = defineProps(["src", "imagAttr", "wrapAttr", "tag"]);
import { useElementVisibility } from "@vueuse/core";
import { useTemplateRef } from "vue";
const target = useTemplateRef("target");
const isVisible = useElementVisibility(target);
const isLoaded = ref(0);

watch(isVisible, async (v) => {
  if (v && !isLoaded.value) {
    isLoaded.value = await loadImage(props.src);
  }
});
</script>
